import styled from 'styled-components';
import { showHide } from '../../utils';
export default styled.div `
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => (align === 'left' ? 'flex-start' : `flex-end`)};
  ${showHide()};

  [aria-hidden='true'] {
    display: none !important;
  }
`;
//# sourceMappingURL=ToggleStyle.js.map